<template>
  <b-field
    :label="`Site Url ${required ? '*' : ''}`"
    :message="hint"
  >
    <b-input
      ref="url"
      v-model="field"
      :disabled="disabled || locked"
      :readonly="locked"
      placeholder="yourdomain.com"
    />
  </b-field>
</template>

<script>
export default {
  name: "SiteUrlField",
  props: {
    url: {
      type: String,
      default: null,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    locked: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      field: this.url || ""
    };
  },
  computed: {
    /* Accepts anything URL-ish – a bare hostname (apple.com), a full URL
    (https://www.apple.com/) or one with a path/query – and derives the
    protocol, fqdn and canonical url from it. */
    sanitised() {
      const raw = this.$_.trim(this.field);
      if (!raw) return null;
      let parsed;
      try {
        parsed = new URL(/^[a-z][a-z0-9+.-]*:\/\//i.test(raw) ? raw : `https://${raw}`);
      } catch {
        return null;
      }
      if (!["http:", "https:"].includes(parsed.protocol)) return null;
      const host = parsed.hostname.toLowerCase();
      const www = host.startsWith("www.") ? "www." : "";
      const fqdn = host.replace(/^www\./, "");
      const protocol = `${parsed.protocol}//${www}`;
      return {
        protocol,
        fqdn,
        url: `${protocol}${fqdn}`
      };
    },
    isValid() {
      if (!this.sanitised) return false;
      if (!this.$v.isFQDN(this.sanitised.fqdn)) return false;
      return this.$v.isURL(this.sanitised.url, {
        protocols: ["http", "https"]
      });
    },
    hint() {
      if (this.locked || !this.isValid) return "";
      if (this.sanitised.url === this.$_.trim(this.field)) return "";
      return `We'll use ${this.sanitised.url}`;
    }
  },
  watch: {
    field: {
      handler() {
        this.$emit("change", this.isValid ? this.sanitised : null);
      },
      immediate: true
    }
  },
  mounted() {
    if (this.autofocus) {
      this.$refs.url.$el.querySelector("input").focus();
    }
  }
};
</script>
